<template>
  <div class="tongue-diagnosis-page">
    <!-- 背景图片，沿用 HealthService 风格 -->
    <img class="page-bg" src="/images/backgrounds/home-bg.png" alt="背景"/>

    <!-- Logo -->
    <img class="page-logo" :src="logoImage" alt="Logo"/>

    <!-- 返回按钮 -->
    <img class="page-back-btn" @click="onHeaderBtnClick" :src="backButtonImage" alt="返回"/>

    <!-- 内容区域 -->
    <div class="content-box">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <!-- 舌诊结果：舌面/舌底+体质 -->
      <div v-else class="service-section">
       <div class="baige"> 
        <div class="bodyMass-title">舌诊结果<div class="bodyMass-div"></div></div>
        <div v-if="displayData" class="tongue-result-body">
          <div class="tongue-result-content">
            <div class="tongue-pics">
              <img
                  class="tongue-result-bg"
                  src="/images/tongue/tongue-result.png"
                  alt="舌诊结果背景"
              />

              <div class="pic-item">
                <div class="pic-img-wrapper">
                  <ImageViewer
                      :src="displayData.upperTongueImageUrl"
                      alt="舌面图"
                  />
                </div>
                <div class="pic-title">舌面图</div>
              </div>
              <div class="pic-item">
                <div class="pic-img-wrapper">
                  <ImageViewer
                      :src="displayData.lowerTongueImageUrl"
                      alt="舌底图"
                  />
                </div>
                <div class="pic-title">舌底图</div>
              </div>
            </div>

            <div class="constitution-result">
              <div class="constitution-label">您的辨证体质为</div>
              <div class="constitution-value-card">
                <img
                    class="constitution-bg"
                    src="/images/home/container-649@1x.png"
                    alt="体质背景"
                />
                <div class="constitution-value">
                  {{ displayData.constitution || '—' }}
                </div>
              </div>
              <div v-if="displayData.constitutionDesc" class="constitution-desc">
                {{ displayData.constitutionDesc }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">暂无数据</div>
       </div> 
      </div>

      <!-- 舌像分析 -->
      <div class="service-section">
       <div class="baige">
        <div class="bodyMass-title">舌像分析
          <!-- <div class="bodyMass-div"></div> -->
        </div>

        <div v-if="displayData" class="tongue-analysis-body">
          <div class="analysis-top">
            <div class="analysis-top-inner">
              <div class="analysis-side-text">
                <div
                    class="analysis-side-item"
                    v-for="(item, idx) in leftSideTexts"
                    :key="`left-${idx}`"
                >
                  <div class="side-text-title">{{ item.title }}</div>
                  <div class="side-text-value">{{ item.value }}</div>
                </div>
              </div>

              <div class="tongue-schema">
                <img
                    class="tongue-schema-img"
                    src="/images/tongue/tongue-schema.png"
                    alt="舌像示意图"
                />
              </div>

              <div class="analysis-side-text">
                <div
                    class="analysis-side-item"
                    v-for="(item, idx) in rightSideTexts"
                    :key="`right-${idx}`"
                >
                  <div class="side-text-title">{{ item.title }}</div>
                  <div class="side-text-value">{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 下方分析列表 -->
          <div class="analysis-list">
            
            <div
                v-for="(item, index) in tongueAnalysisDisplay"
                :key="index"
                class="analysis-item"
            >
              <div class="analysis-title-row">
                {{ item.label }}
              </div>
              <div class="analysis-line">
                <span class="analysis-tag analysis-tag-main">【{{ item.mainValue }}】</span>
                <span class="analysis-text">{{ item.subTitle }}</span>
              </div>
              <div class="analysis-line">
                <span class="analysis-tag analysis-tag-meaning">【病理意义】</span>
                <span class="analysis-text">{{ item.pathology }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="empty-state">暂无数据</div>
       </div>   
      </div>

      <!-- 易患病症 -->
      <div class="service-section">
       <div class="baige">
        <div class="bodyMass-title">易患病症
          <!-- <div class="bodyMass-div"></div> -->
        </div>

        <div v-if="displayData" class="disease-body">
          <div class="disease-header">
            <!-- 上方右侧预警框，单独一行靠右 -->
            <div class="risk-summary" v-if="highRiskCount > 0">
              <img
                  class="risk-icon"
                  src="/images/tongue/risk-warning.png"
                  alt="风险"
              />
              <span class="risk-text">
                共 <span class="risk-number">{{ highRiskCount }}</span> 项患病风险预警
              </span>
            </div>
          </div>

          <!-- 左侧风险列 + 右侧柱状图在同一行 -->
          <div class="disease-row">
            <div class="risk-y-labels">
              <span class="risk-y-item high">高风险</span>
              <span class="risk-y-item medium">中风险</span>
              <span class="risk-y-item low">低风险</span>
            </div>

            <div class="disease-chart-wrapper">
              <Chart :option="diseaseChartOption" height="100%"/>
            </div>
          </div>

          <div class="disease-desc-card" v-if="displayData.predisposition">
            <div class="desc-title">说明：</div>
            <div class="desc-text">
              {{ displayData.predisposition }}
            </div>
          </div>
        </div>

        <div v-else class="empty-state">暂无数据</div>
       </div>  
      </div>

      <!-- 主要表现 -->
      <div class="service-section">
       <div class="baige">
        <div class="bodyMass-title">主要表现
          <!-- <div class="bodyMass-div"></div> -->
        </div>

        <div v-if="displayData" class="manifest-body">
          <div class="manifest-column">
            <span
                v-for="(item, index) in leftManifestTags"
                :key="`left-${index}`"
                class="manifest-tag"
            >
              {{ item }}
            </span>
          </div>

          <div class="human-outline">
            <img
                v-if="humanOutlineExist"
                src="/images/tongue/human-outline.png"
                alt="人体轮廓"
                class="human-img"
            />
            <div v-else class="human-placeholder">人体轮廓</div>
          </div>

          <div class="manifest-column">
            <span
                v-for="(item, index) in rightManifestTags"
                :key="`right-${index}`"
                class="manifest-tag"
            >
              {{ item }}
            </span>
          </div>
        </div>

        <div v-else class="empty-state">暂无数据</div>
       </div>  
      </div>

      <!-- 发生原因 -->
      <div class="service-section">
       <div class="baige">
        <div class="bodyMass-title">发生原因
          <!-- <div class="bodyMass-div"></div> -->
        </div>
        <div v-if="occurReasons && occurReasons.length" class="causes-body">
          <ul class="causes-list">
            <li
                v-for="(cause, index) in occurReasons"
                :key="index"
                class="cause-item"
            >
              <span class="cause-dot"></span>
              <span class="cause-text">{{ cause }}</span>
            </li>
          </ul>
        </div>
        <div v-else class="empty-state">暂无数据</div>
       </div>  
      </div>

      <!-- 底部间距 -->
      <div class="bottom-spacer"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ImageViewer from '@/components/common/ImageViewer.vue'
import Chart from '@/components/common/Chart.vue'

export default {
  name: 'TongueDiagnosis',
  components: {
    ImageViewer,
    Chart
  },
  data () {
    return {
      loading: false,
      humanOutlineExist: true,
      logoImage: '/images/backgrounds/title3.png',
      backButtonImage: '/images/home/header-back@1x.png',
    }
  },
  computed: {
    ...mapGetters('report', ['tongueData', 'homeData']),

    // 舌像分析标题下面的动态文本（可按产品口径调整）
    analysisSummaryText () {
      if (!this.displayData) return ''
      const c = this.displayData.constitution ? `体质：${this.displayData.constitution}` : ''
      const p = this.displayData.commonPerformance && this.displayData.commonPerformance.length
          ? `主要表现：${this.displayData.commonPerformance.slice(0, 3).join('、')}${this.displayData.commonPerformance.length > 3 ? '…' : ''}`
          : ''
      return [c, p].filter(Boolean).join('｜')
    },

    // 标题固定，值从接口更新
    leftSideTexts () {
      const d = this.displayData
      return [
        { title: '舌色', value: (d && d.tongueColorName) ? d.tongueColorName : '—' },
        { title: '津液', value: (d && d.fluidName) ? d.fluidName : '—' },
        { title: '舌形', value: (d && d.tongueShapeName) ? d.tongueShapeName : '—' }
      ]
    },
    rightSideTexts () {
      const d = this.displayData
      return [
        { title: '苔色', value: (d && d.coatingColorName) ? d.coatingColorName : '—' },
        { title: '苔质', value: (d && d.coatingQualityName) ? d.coatingQualityName : '—' },
        { title: '脉络', value: (d && d.veinName) ? d.veinName : '—' }
      ]
    },

    displayData () {
      const t = this.tongueData
      if (!t) return null

      let treatPlan = null
      if (t.treatplanjson) {
        try {
          treatPlan = JSON.parse(t.treatplanjson)
        } catch (e) {
          console.warn('parse treatplanjson error', e)
        }
      }

      return {
        lowerTongueImageUrl: t.lowerTongueImageUrl || t.tongueBody || '',
        upperTongueImageUrl: t.upperTongueImageUrl || '',
        constitution: t.constitutionnames || '',
        constitutionDesc: t.constitutiondescribe || '',
        fluidName: t.bodyfluidnames || '',
        fluidHtml: t.bodyfluiddescribe || '',
        coatingColorName: t.colorofmossnames || '',
        coatingColorHtml: t.colorofmossdescribe || '',
        tongueColorName: t.coloroftonguenames || '',
        tongueColorHtml: t.coloroftonguedescribe || '',
        coatingQualityName: t.mossnames || '',
        coatingQualityHtml: t.mossdescribe || '',
        tongueShapeName: t.shapeoftonguenames || '',
        tongueShapeHtml: t.shapeoftonguedescribe || '',
        veinName: t.veinnames || '',
        veinHtml: t.veindescribe || '',
        predisposition: treatPlan?.predisposition || '',
        mainPerformanceFromPlan: treatPlan?.mainPerformance || '',
        occurReasonFromPlan: Array.isArray(treatPlan?.occurReason) ? treatPlan.occurReason : [],
        diseaseRiskList: Array.isArray(t.diseaseRiskList) ? t.diseaseRiskList : [],
        commonPerformance: Array.isArray(t.commonPerformance)
            ? t.commonPerformance
            : (t.commonPerformance && typeof t.commonPerformance === 'string'
                ? t.commonPerformance.split(/[；;。]/).filter(Boolean)
                : (treatPlan?.mainPerformance
                    ? treatPlan.mainPerformance.split(/[；;。]/).filter(Boolean)
                    : []))
      }
    },

    tongueAnalysisDisplay () {
      if (!this.displayData) return []

      const parseDescribe = (htmlStr, defaultMainText) => {
        if (!htmlStr) {
          return {
            subTitle: defaultMainText || '',
            pathology: ''
          }
        }
        const pure = htmlStr.replace(/<br\s*\/?>/gi, '\n')
        const lines = pure.split('\n').map(l => l.trim()).filter(Boolean)

        let subTitle = defaultMainText || ''
        let pathology = ''

        if (lines.length > 0) {
          const line1 = lines[0].replace(/^【.*?】/, '').trim()
          if (line1) subTitle = line1
        }

        const meaningLine = lines.find(l => l.indexOf('病理意义') !== -1)
        if (meaningLine) {
          pathology = meaningLine.replace(/【病理意义】/g, '').trim()
        }

        return {
          subTitle,
          pathology
        }
      }

      const d = this.displayData

      const fluid = parseDescribe(d.fluidHtml, '舌苔干湿适中')
      const coatColor = parseDescribe(d.coatingColorHtml, '')
      const tongueColor = parseDescribe(d.tongueColorHtml, '')
      const coatQuality = parseDescribe(d.coatingQualityHtml, '')
      const tongueShape = parseDescribe(d.tongueShapeHtml, '')
      const vein = parseDescribe(d.veinHtml, '')

      return [
        {
          label: '津液',
          mainValue: d.fluidName || '—',
          subTitle: fluid.subTitle,
          pathology: fluid.pathology
        },
        {
          label: '苔色',
          mainValue: d.coatingColorName || '—',
          subTitle: coatColor.subTitle,
          pathology: coatColor.pathology
        },
        {
          label: '舌色',
          mainValue: d.tongueColorName || '—',
          subTitle: tongueColor.subTitle,
          pathology: tongueColor.pathology
        },
        {
          label: '苔质',
          mainValue: d.coatingQualityName || '—',
          subTitle: coatQuality.subTitle,
          pathology: coatQuality.pathology
        },
        {
          label: '舌形',
          mainValue: d.tongueShapeName || '—',
          subTitle: tongueShape.subTitle,
          pathology: tongueShape.pathology
        },
        {
          label: '脉络',
          mainValue: d.veinName || '—',
          subTitle: vein.subTitle,
          pathology: vein.pathology
        }
      ]
    },

    diseaseData () {
      if (!this.displayData || !this.displayData.diseaseRiskList) return []
      return this.displayData.diseaseRiskList.map(item => ({
        name: item.diseaseName,
        value: item.riskScore || 0,
        level: item.riskLevel
      }))
    },

    highRiskCount () {
      if (!this.displayData || !this.displayData.diseaseRiskList) return 0
      return this.displayData.diseaseRiskList.filter(
          d => d.riskLevel === '高风险'
      ).length
    },

    leftManifestTags () {
      if (!this.displayData || !this.displayData.commonPerformance) return []
      const list = this.displayData.commonPerformance
      const half = Math.ceil(list.length / 2)
      return list.slice(0, half)
    },

    rightManifestTags () {
      if (!this.displayData || !this.displayData.commonPerformance) return []
      const list = this.displayData.commonPerformance
      const half = Math.ceil(list.length / 2)
      return list.slice(half)
    },

    occurReasons () {
      if (!this.displayData || !this.displayData.occurReasonFromPlan) return []
      return this.displayData.occurReasonFromPlan
    },

    diseaseChartOption () {
      if (!this.diseaseData.length) return {}
      const scores = this.diseaseData.map(i => i.value)
      const max = Math.max.apply(null, scores) || 1

      const levelColor = level => {
        if (level === '高风险') {
          return {
            type: 'linear',
            x: 0,
            y: 1,
            x2: 0,
            y2: 0,
            colorStops: [
              { offset: 0, color: '#FF8A65' },
              { offset: 1, color: '#E53935' }
            ]
          }
        }
        if (level === '中风险') {
          return {
            type: 'linear',
            x: 0,
            y: 1,
            x2: 0,
            y2: 0,
            colorStops: [
              { offset: 0, color: '#FFB74D' },
              { offset: 1, color: '#FF9800' }
            ]
          }
        }
        return {
          type: 'linear',
          x: 0,
          y: 1,
          x2: 0,
          y2: 0,
          colorStops: [
            { offset: 0, color: '#FFE082' },
            { offset: 1, color: '#FFD54F' }
          ]
        }
      }

      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter (params) {
            if (!params || !params.length) return ''
            const p = params[0]
            const data = p.data || {}
            return `${data.name}<br/>风险等级：${data.level}<br/>风险得分：${data.value}`
          }
        },
        grid: {
          left: '10%',
          right: '6%',
          bottom: '8%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.diseaseData.map(i => i.name),
          axisLine: { lineStyle: { color: '#CFD8DC' } },
          axisTick: { show: false },
          axisLabel: {
            color: '#546E7A',
            fontSize: 12,
            rotate:45
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max,
          splitNumber: 3,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#FFE0B2'
            }
          },
          axisLabel: { show: false }
        },
        series: [
          {
            name: '易患病症',
            type: 'bar',
            data: this.diseaseData.map(i => ({
              ...i,
              itemStyle: {
                color: levelColor(i.level)
              }
            })),
            barWidth: '40%',
            label: {
              show: true,
              position: 'top',
              color: '#455A64',
              fontSize: 12
            }
          }
        ]
      }
    }
  },

  async created () {
    if (!this.tongueData) {
      this.loading = true
      try {
        const detectionNo = this.$route.query.id || this.$route.query.detectionNo
        if (!detectionNo) {
          const currentUrl = window.location.href
          const idMatch = currentUrl.match(/[?&]id=([^&]*)/)
          if (idMatch && idMatch[1]) {
            detectionNo = idMatch[1]
          }
        }

        if (!detectionNo) {
          console.error('缺少检测编号 id3 或 detectionNo')
          this.loading = false
          return
        }
        await this.fetchHomeData({ detectionNo })
      } catch (e) {
        console.error('Failed to load home data:', e)
      } finally {
        this.loading = false
      }
    }
  },

  methods: {
    ...mapActions('report', ['fetchHomeData']),
    onHeaderBtnClick () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.tongue-diagnosis-page {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

/* 背景图片 */
.page-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

// Logo
.page-logo {
  position: absolute;
  left: 40rpx;
  top: 50rpx;
  width: 315.6rpx;
  height: 100rpx;
  z-index: 2;
}

// 返回按钮
.page-back-btn {
  position: absolute;
  left: 495rpx;
  top: 65rpx;
  width: 220rpx;
  height: 70rpx;
  border-radius: 10rpx;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6rpx;
  box-sizing: border-box;
  border: 1px solid #FFFFFF;
}

/* 内容区域 */
.content-box {
  position: absolute;
  left: 36rpx;
  top: 154rpx;
  width: 677rpx;
  z-index: 1;
}

/* 加载状态 */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80rpx 40rpx;
  min-height: 400rpx;

  .loading-spinner {
    width: 80rpx;
    height: 80rpx;
    border: 8rpx solid #f3f3f3;
    border-top: 8rpx solid #0E6EB8;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loading-text {
    margin-top: 32rpx;
    font-size: 28rpx;
    color: #666;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 通用服务模块容器 */
.service-section {
  position: relative;
  margin-top: 31.25rpx;
  width: 677rpx;
  background: #FFFFFF;
  padding-bottom: 30rpx;
  z-index: 2;
  border-radius: 20rpx;
  padding: 7rpx;
  box-sizing: border-box;
  background: rgba(175, 225, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 2px 10px 0px rgba(42, 150, 225, 0.3);
}

.bodyMass-title {
  position: relative;
  left: 18.7rpx;
  top: 18.7rpx;    
  // height: 52px;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 33.6rpx;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
  z-index: 6;
}

.bodyMass-div{
  position: absolute;
  left: 0px;
  top: 30.7rpx;
  width: 140rpx;
  height: 9.34rpx;
  z-index: -1;
  /* 主色 */
  background: linear-gradient(270deg, #3D8AFE 0%, #5CC0FF 100%);
}
/* 模块标题 */
.section-title {
  position: relative;
  left: 0;
  top: 0;
  width: 177rpx;
  height: 46.875rpx;
  border-radius: 26rpx 26rpx 26rpx 0;
  text-align: center;
  line-height: 46.875rpx;
  font-size: 26rpx;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(284deg, #2397F0 22%, #94DE30 99%);
}

/* 舌诊结果模块 */
.tongue-result-body {
  position: relative;
  padding-top: 30rpx;
  overflow: hidden;
}

/* 舌诊结果背景图（img） */
.tongue-result-bg {
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  height: auto;
  z-index: 0;
}

/* 内容叠加在背景上 */
.tongue-result-content {
  position: relative;
  z-index: 1;
}

/* 舌面/舌底图 */
.tongue-pics {
  display: flex;
  justify-content: space-around;
  gap: 16rpx;
  margin-top: 40rpx;
  padding: 16rpx 46.875rpx 0;
}

.pic-item {
  width: 25%;
  border-radius: 12rpx;
  padding: 12rpx 8rpx;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(14, 110, 184, 0.02);
}

.pic-img-wrapper {
  width: 100%;
}

.pic-title {
  font-size: 24rpx;
  color: #455a64;
  margin-top: 12rpx;
}

/* 体质结果 */
.constitution-result {
  margin-top: 24rpx;
  padding: 40rpx 46.875rpx 10rpx;
}

.constitution-label {
  font-size: 26rpx;
  color: #3d3d3d;
  font-weight: bold;
  margin-bottom: 8rpx;
}

.constitution-value-card {
  position: relative;
  width: 100%;
  height: 104.17rpx;
}

.constitution-bg {
  width: 100%;
  height: 100%;
}

.constitution-value {
  position: absolute;
  top: 25.8rpx;
  width: 100%;
  text-align: center;
  height: 38.54rpx;
  font-size: 31.25rpx;
  font-weight: bold;
  color: #ffffff;
}

.constitution-desc {
  margin-top: 16rpx;
  font-size: 24rpx;
  color: #546e7a;
  line-height: 1.6;
}

/* 舌像分析模块 */
.tongue-analysis-body {
  padding-top: 30rpx;
}

/* 舌像分析标题下面动态文本 */
.analysis-summary {
  margin: 12rpx 46.875rpx 0;
  padding: 12rpx 16rpx;
  background: #f7fbff;
  border-radius: 16rpx;
  font-size: 24rpx;
  color: #455a64;
  line-height: 1.6;
}

/* 上部：整体居中 */
.analysis-top {
  margin-top: 20rpx;
  display: flex;
  justify-content: center;
}

.analysis-top-inner {
  display: flex;
}

/* 左右文字列：标题+值 */
.analysis-side-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 240rpx;
  width: 120rpx;
  flex-shrink: 0;
}

.analysis-side-text:first-child {
  margin-right: 24rpx;
}

.analysis-side-text:last-child {
  margin-left: 24rpx;
}

.analysis-side-item {
  text-align: center;
  line-height: 1.2;
}

.side-text-title {
  font-size: 24rpx;
  color: #8bc34a;
  font-weight: 600;
}

.side-text-value {
  margin-top: 8rpx;
  font-size: 22rpx;
  color: #0e6eb8;
  font-weight: 700;
}

/* 中间示意图 */
.tongue-schema {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tongue-schema-img {
  width: 420rpx;
  height: auto;
  aspect-ratio: 1184 / 807;
}

/* 下部分析列表 */
.analysis-list {
  margin: 0 46.875rpx 0;
}

.analysis-item + .analysis-item {
  margin-top: 24rpx;
}

.analysis-title-row {
  font-size: 28rpx;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8rpx;
}

.analysis-line {
  font-size: 24rpx;
  color: #546e7a;
  line-height: 1.6;
}

.analysis-tag {
  font-weight: 600;
  margin-right: 8rpx;
}

.analysis-tag-main {
  color: #0e6eb8;
}

.analysis-tag-meaning {
  color: #333333;
}

/* 易患病症模块 */
.disease-body {
  padding-top: 30rpx;
}

/* 顶部：只有右侧预警框 */
.disease-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0 46.875rpx 12rpx;
}

/* 左侧标签列 + 右侧柱状图在同一行 */
.disease-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin: 0 46.875rpx;
  height: 40vh; /* fixed height for android compatibility, scales with viewport */
}

/* 左侧标签列 */
.risk-y-labels {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center; 
  width: 60rpx;
  /* use responsive rpx-based font size so it scales on android */
  font-size: clamp(12rpx, 1.6vw, 22rpx);
  color: #ff7043;
  flex-shrink: 0;
  margin-right: 24rpx;
}

.risk-y-item {
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  text-orientation: upright;
  text-align: center;
  flex: 1 1 auto;
  padding: 6rpx 4rpx;
  line-height: 1;
  box-sizing: border-box;
  border: #f0ad4e 1px solid;
  word-break: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: clamp(12px, 1.4vw, 18px);
}

.risk-y-item.high {
  color: #FF4D4F;
  border-color: #FF4D4F;
}

.risk-y-item.medium {
  color: #fb8c00;
  border-color: #fb8c00;
}

.risk-y-item.low {
  color: #FFD666;
  border-color: #FFD666;
}

/* 右上角预警框保持不变 */
.risk-summary {
  display: inline-flex;
  align-items: center;
  padding: 8rpx 16rpx;
  border-radius: 16rpx;
  border: 2rpx solid #ff5252;
  background: #ffecec;
}

.risk-icon {
  width: 32rpx;
  height: 32rpx;
  margin-right: 8rpx;
}

.risk-text {
  font-size: 24rpx;
  color: #e53935;
  font-weight: 600;
}

.risk-number {
  font-size: 30rpx;
  font-weight: 700;
  margin: 0 4rpx;
}

/* 柱状图区域：占剩余宽度 */
.disease-chart-wrapper {
  flex: 1;
  /* remove fixed height, let it stretch to parent */
}

/* 下部说明卡片 */
.disease-desc-card {
  margin: 24rpx 46.875rpx 0;
  background: #f7fbff;
  border-radius: 20rpx;
  padding: 16rpx 12rpx;
  font-size: 24rpx;
  color: #455a64;
  line-height: 1.6;
}

.desc-title {
  font-weight: 600;
  margin-bottom: 4rpx;
}

/* 主要表现模块 */
.manifest-body {
  padding: 30rpx 46.875rpx 0;
  /* flex fallback for old WebViews */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  /* stretch columns to the full height so they can space their children */
  align-items: stretch;

  /* grid layout when available */
  display: -ms-grid;
  display: -webkit-grid;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 24rpx;
  align-items: stretch;
}

.manifest-column {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* spread tags vertically */
  gap: 16rpx;
  align-items: center;
  /* allow columns to grow in flex fallback */
  flex: 1;
}

.manifest-tag {
  min-width: 192rpx;
  text-align: center;
  padding: 8rpx 16rpx;
  border-radius: 32rpx;
  border: 2rpx solid #0e6eb8;
  background: #f7fbff;
  color: #0e6eb8;
  font-size: 24rpx;
}

.human-outline {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center; /* keep image centered when container stretches */
}

.human-img {
  width: 160rpx;
  height: auto;
}

.human-placeholder {
  width: 160rpx;
  height: 320rpx;
  border-radius: 24rpx;
  border: 2rpx dashed #b0bec5;
  font-size: 24rpx;
  color: #90a4ae;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 发生原因模块 */
.causes-body {
  margin: 30rpx 46.875rpx 0;
  background: #f7fbff;
  border-radius: 20rpx;
  padding: 20rpx 16rpx;
}

.causes-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.cause-item {
  display: flex;
  align-items: flex-start;
  font-size: 24rpx;
  color: #455a64;
  line-height: 1.7;
  margin-bottom: 8rpx;
}

.cause-dot {
  width: 12rpx;
  height: 12rpx;
  border-radius: 50%;
  background: #0e6eb8;
  margin-top: 8rpx;
  margin-right: 12rpx;
}

.cause-text {
  flex: 1;
}

/* 空状态 */
.empty-state {
  margin-top: 24rpx;
  text-align: center;
  color: #90a4ae;
  font-size: 26rpx;
}

/* 底部间距 */
.bottom-spacer {
  height: 50rpx;
  position: relative;
}

.baige{
  width: 654rpx;
  background-color: #fff;
  border-radius: 20rpx;
  padding-bottom: 30rpx;
}
</style>
